import React from 'react'
import {getMyOrderPreferences_preferences} from '@data/queries/preferences/__generated__/getMyOrderPreferences'
import {websiteInitialData_cached_website} from '@data/queries/website/__generated__/websiteInitialData_cached'
import useQuery from '@packages/apollo-hooks/lib/useApolloQuery'
import Links from '@page-components/Layout/Website/Layouts/Default/Navbar/Links'
import gql from 'graphql-tag'
import Link from 'next/link'

import TopRibbon from './TopRibbon/index'
import Account from './Account'
import Cart from './Cart'
import Delivery from './Delivery'
import SearchBox from './SearchBox'

import styles from './styles.module.css'

export interface NavbarCPGProps {
  website: websiteInitialData_cached_website
  userPreferences?: getMyOrderPreferences_preferences
  loading: boolean
  layout: string
}

export default function NavbarCPG(props) {
  const {website, userPreferences, loading, layout} = props
  const {me} = useQuery({
    query: gql`
      query getUserInfoNavbar($websiteId: ID) {
        me {
          _id
          name
          email
          roles
          roleInWebsite(websiteId: $websiteId) {
            _id
            role
          }
          pointsInWebsite(websiteId: $websiteId)
        }
      }
    `,
    variables: {websiteId: website._id}
  })
  const navbar = (website && website.navbarConfiguration) || {
    backgroundColor: '#fff',
    textColor: '#111'
  }
  const finalLogo = navbar.logo || website.logo
  return (
    <header className={styles.header}>
      <TopRibbon />
      <div className={styles.headerActions}>
        <div className={styles.logo}>
          <Link href="/">
            <img src={finalLogo.url} alt="Logo" />
          </Link>
        </div>
        <SearchBox layout={layout} />
        <Delivery preferences={userPreferences} loading={loading} />
        <Account me={me} website={website} />
        <Cart preferences={userPreferences} layout={layout} website={website} />
      </div>
      <Links links={navbar.links} categories={website.categories} cpg />
    </header>
  )
}
